// Assessment basis for assessment sessions (read by the claim project).
// 'fa_1_2' = Assessment F.A. 1.2. (per Pax), 'fa_2_2' = Assessment F.A. 2.2. (Final),
// '' / null = per Duration (nothing is displayed for it).
const LABELS = {
  fa_1_2: 'Assessment F.A. 1.2.',
  fa_2_2: 'Assessment F.A. 2.2.',
};
const HINTS = { fa_1_2: 'Per Pax', fa_2_2: 'Final' };

// Display label — '' for per Duration so callers can skip rendering it.
export function assessmentBasisLabel(value) {
  return LABELS[value] || '';
}

// What the option means (per Pax / Final) — for tooltips.
export function assessmentBasisHint(value) {
  return HINTS[value] || '';
}
